<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="site"
          :items="sites"
          :rules="[v => !!v || '建案必須填寫']"
          label="建案"
          required
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="site === '樂嵩豐'">
      <v-col cols="12">
        <v-select
          v-model="address"
          :items="leaddress"
          :rules="[v => !!v || '地址必須填寫']"
          label="樂嵩豐地址"
          required
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="site === '耀嵩豐'">
      <v-col cols="12">
        <v-select
          v-model="address"
          :items="yaoaddress"
          :rules="[v => !!v || '地址必須填寫']"
          label="耀嵩豐地址"
          required
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="site !== '樂嵩豐' && site !== '耀嵩豐'">
      <v-col>
        <v-text-field
          v-model="address"
          :rules="[v => !!v || '地址必須填寫']"
          label="地址"
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          depressed
          block
          @click="searchRepair"
          color="blue-grey white--text"
          >搜尋</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col v-if="searchRepairs.length === 0" class="d-flex justify-center">
        查無資料，請選擇查詢工地
      </v-col>
      <v-col
        v-else
        v-for="(repair, index) in searchRepairs"
        :key="index"
        cols="12"
      >
        <card
          :id="repair.id"
          :site="repair.site"
          :completed="repair.completed"
          :description="repair.description"
          :problemType="repair.problemType"
          :created_at="repair.created_at"
          :repairItems="repair.repairItems"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Card from "@/components/Card";
import { repairsCollection } from "@/db";

export default {
  name: "SearchAddress",
  data: () => ({
    searchRepairs: [],
    address: "",
    site: "",
    sites: [
      "樂嵩豐",
      "耀嵩豐",
      "悅嵩豐",
      "松丰",
      "文川",
      "淨美墅",
      "世璽",
      "帝門",
      "自由鑫貴",
      "綠園市2",
      "綠園市1",
      "品美術",
      "觀美術",
      "大社官邸",
      "嵩豐臻寶",
      "狀元邸",
      "嵩之園",
      "千禧園",
      "三荷園",
      "東方伯爵"
    ],
    leaddress: [
      "華欣路99號大樓管理室",
      "華欣路99號1.2樓",
      "華欣路99號3樓之1",
      "華欣路99號3樓之2",
      "華欣路99號3樓之3",
      "華欣路99號3樓之5",
      "華欣路99號3樓之6",
      "華欣路99號3樓之7",
      "華欣路99號4樓之1",
      "華欣路99號4樓之2",
      "華欣路99號4樓之3",
      "華欣路99號4樓之5",
      "華欣路99號4樓之6",
      "華欣路99號4樓之7",
      "華欣路99號5樓之1",
      "華欣路99號5樓之2",
      "華欣路99號5樓之3",
      "華欣路99號5樓之5",
      "華欣路99號5樓之6",
      "華欣路99號5樓之7",
      "華欣路99號6樓之1",
      "華欣路99號6樓之2",
      "華欣路99號6樓之3",
      "華欣路99號6樓之5",
      "華欣路99號6樓之6",
      "華欣路99號6樓之7",
      "華欣路99號7樓之1",
      "華欣路99號7樓之2",
      "華欣路99號7樓之3",
      "華欣路99號7樓之5",
      "華欣路99號7樓之6",
      "華欣路99號7樓之7",
      "華欣路99號8樓之1",
      "華欣路99號8樓之2",
      "華欣路99號8樓之3",
      "華欣路99號8樓之5",
      "華欣路99號8樓之6",
      "華欣路99號8樓之7",
      "華欣路99號9樓之1",
      "華欣路99號9樓之2",
      "華欣路99號9樓之3",
      "華欣路99號9樓之5",
      "華欣路99號9樓之6",
      "華欣路99號9樓之7",
      "華欣路99號10樓之1",
      "華欣路99號10樓之2",
      "華欣路99號10樓之3",
      "華欣路99號10樓之5",
      "華欣路99號10樓之6",
      "華欣路99號10樓之7",
      "華欣路99號11樓之1",
      "華欣路99號11樓之2",
      "華欣路99號11樓之3",
      "華欣路99號11樓之5",
      "華欣路99號11樓之6",
      "華欣路99號11樓之7",
      "華欣路99號12樓之1",
      "華欣路99號12樓之2",
      "華欣路99號12樓之3",
      "華欣路99號12樓之5",
      "華欣路99號12樓之6",
      "華欣路99號12樓之7",
      "華欣路99號13樓之1",
      "華欣路99號13樓之2",
      "華欣路99號13樓之3",
      "華欣路99號13樓之5",
      "華欣路99號13樓之6",
      "華欣路99號13樓之7",
      "華欣路99號14樓之1",
      "華欣路99號14樓之2",
      "華欣路99號14樓之3",
      "華欣路99號14樓之5",
      "華欣路99號14樓之6",
      "華欣路99號14樓之7",
      "華欣路99號15樓之1",
      "華欣路99號15樓之3",
      "華欣路99號15樓之6"
    ],
    yaoaddress: [
      "博愛四路309號管理委員會",
      "博愛四路309號",
      "博愛四路309號2樓",
      "博愛四路309號3樓之1",
      "博愛四路309號3樓之2",
      "博愛四路309號3樓之3",
      "博愛四路309號3樓之5",
      "博愛四路309號3樓之6",
      "博愛四路309號3樓之7",
      "博愛四路309號4樓之1",
      "博愛四路309號4樓之2",
      "博愛四路309號4樓之3",
      "博愛四路309號4樓之5",
      "博愛四路309號4樓之6",
      "博愛四路309號4樓之7",
      "博愛四路309號5樓之1",
      "博愛四路309號5樓之2",
      "博愛四路309號5樓之3",
      "博愛四路309號5樓之5",
      "博愛四路309號5樓之6",
      "博愛四路309號5樓之7",
      "博愛四路309號6樓之1",
      "博愛四路309號6樓之2",
      "博愛四路309號6樓之3",
      "博愛四路309號6樓之5",
      "博愛四路309號6樓之6",
      "博愛四路309號6樓之7",
      "博愛四路309號7樓之1",
      "博愛四路309號7樓之2",
      "博愛四路309號7樓之3",
      "博愛四路309號7樓之5",
      "博愛四路309號7樓之6",
      "博愛四路309號7樓之7",
      "博愛四路309號8樓之1",
      "博愛四路309號8樓之2",
      "博愛四路309號8樓之3",
      "博愛四路309號8樓之5",
      "博愛四路309號8樓之6",
      "博愛四路309號8樓之7",
      "博愛四路309號9樓之1",
      "博愛四路309號9樓之2",
      "博愛四路309號9樓之3",
      "博愛四路309號9樓之5",
      "博愛四路309號9樓之6",
      "博愛四路309號9樓之7",
      "博愛四路309號10樓之1",
      "博愛四路309號10樓之2",
      "博愛四路309號10樓之3",
      "博愛四路309號10樓之5",
      "博愛四路309號10樓之6",
      "博愛四路309號10樓之7",
      "博愛四路309號11樓之1",
      "博愛四路309號11樓之2",
      "博愛四路309號11樓之3",
      "博愛四路309號11樓之5",
      "博愛四路309號11樓之6",
      "博愛四路309號11樓之7",
      "博愛四路309號12樓之1",
      "博愛四路309號12樓之2",
      "博愛四路309號12樓之3",
      "博愛四路309號12樓之5",
      "博愛四路309號12樓之6",
      "博愛四路309號12樓之7",
      "博愛四路309號13樓之1",
      "博愛四路309號13樓之2",
      "博愛四路309號13樓之3",
      "博愛四路309號13樓之5",
      "博愛四路309號13樓之6",
      "博愛四路309號13樓之7",
      "博愛四路309號14樓之1",
      "博愛四路309號14樓之2",
      "博愛四路309號14樓之3",
      "博愛四路309號14樓之5",
      "博愛四路309號14樓之6",
      "博愛四路309號14樓之7",
      "博愛四路309號15樓之1",
      "博愛四路309號15樓之2",
      "博愛四路309號15樓之3",
      "博愛四路309號15樓之5",
      "博愛四路309號15樓之6",
      "博愛四路309號15樓之7",
      "博愛四路309號16樓之1",
      "博愛四路309號16樓之2",
      "博愛四路309號16樓之3",
      "博愛四路309號16樓之5",
      "博愛四路309號16樓之6",
      "博愛四路309號16樓之7",
      "博愛四路309號17樓之1",
      "博愛四路309號17樓之2",
      "博愛四路309號17樓之3",
      "博愛四路309號17樓之5",
      "博愛四路309號17樓之6",
      "博愛四路309號17樓之7",
      "博愛四路309號18樓之1",
      "博愛四路309號18樓之2",
      "博愛四路309號18樓之3",
      "博愛四路309號18樓之5",
      "博愛四路309號18樓之6",
      "博愛四路309號18樓之7",
      "博愛四路309號19樓之1",
      "博愛四路309號19樓之2",
      "博愛四路309號19樓之3",
      "博愛四路309號19樓之5",
      "博愛四路309號19樓之6",
      "博愛四路309號19樓之7",
      "博愛四路309號20樓之1",
      "博愛四路309號20樓之2",
      "博愛四路309號20樓之3",
      "博愛四路309號20樓之5",
      "博愛四路309號20樓之6",
      "博愛四路309號20樓之7",
      "博愛四路309號21樓之1",
      "博愛四路309號21樓之2",
      "博愛四路309號21樓之3",
      "博愛四路309號21樓之5",
      "博愛四路309號21樓之6",
      "博愛四路309號21樓之7",
      "博愛四路309號22樓之1",
      "博愛四路309號22樓之2",
      "博愛四路309號22樓之3",
      "博愛四路309號22樓之5",
      "博愛四路309號22樓之6",
      "博愛四路309號22樓之7",
      "博愛四路309號23樓之1",
      "博愛四路309號23樓之2",
      "博愛四路309號23樓之3",
      "博愛四路309號23樓之5",
      "博愛四路309號23樓之6",
      "博愛四路309號23樓之7",
      "博愛四路309號24樓之1",
      "博愛四路309號24樓之2",
      "博愛四路309號24樓之3",
      "博愛四路309號24樓之5",
      "博愛四路309號24樓之6",
      "博愛四路309號24樓之7",
      "博愛四路309號25樓之1",
      "博愛四路309號25樓之2",
      "博愛四路309號25樓之3",
      "博愛四路309號25樓之5",
      "博愛四路309號25樓之6",
      "博愛四路309號25樓之7",
      "博愛四路309號26樓之1",
      "博愛四路309號26樓之2",
      "博愛四路309號26樓之3",
      "博愛四路309號26樓之5",
      "博愛四路309號26樓之6",
      "博愛四路309號26樓之7",
      "博愛四路309號27樓之1",
      "博愛四路309號27樓之2",
      "博愛四路309號27樓之3",
      "博愛四路309號27樓之5",
      "博愛四路309號28樓之1",
      "博愛四路309號28樓之2",
      "博愛四路309號28樓之3",
      "博愛四路309號28樓之5"
    ]
  }),
  components: { card: Card },
  methods: {
    searchRepair() {
      this.clearRepairs();
      var query = repairsCollection;
      query = query.where("address", "==", this.address);
      query
        .orderBy("created_at")
        .limit(20)
        .get()
        .then(querySnapshot => {
          querySnapshot.docs.forEach(element => {
            const repairData = {
              id: element.id,
              site: element.data().site,
              completed: element.data().completed,
              repairItems: element.data().repair_items.length,
              problemType: element.data().problemType,
              description: element.data().description,
              created_at: element
                .data()
                .created_at.toDate()
                .toISOString()
                .slice(0, 10)
            };
            this.searchRepairs.push(repairData);
          });
        });
    },
    clearRepairs() {
      this.searchRepairs = [];
    }
  }
};
</script>
